import script from "./noticeTool.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeTool.vue?vue&type=script&setup=true&lang=js"

import "./noticeTool.vue?vue&type=style&index=0&id=8baf5406&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8baf5406"]])

export default __exports__